import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@freelancer/activated-route';

@Injectable()
export class MgidTracking {
  private isEnabled = false;

  constructor(
    private ngZone: NgZone,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isEnabled = isPlatformBrowser(this.platformId);
  }

  trackCustomEvent(buttonId: string): void {
    if (!this.isEnabled) {
      return;
    }
    this.ngZone.runOutsideAngular(() => {
      this.loadTrackingSnippet();
      window._mgq?.push(['MgSensorInvoke', buttonId]);
    });
  }

  loadTrackingSnippet(): void {
    if (
      window._mgq ||
      !this.isEnabled ||
      this.route.snapshot.queryParams.utm_source !== 'mgid'
    ) {
      return;
    }

    window.MgSensorData = window.MgSensorData || [];
    window._mgq = window._mgq || [];

    window.MgSensorData.push({
      cid: 644483,
      lng: 'us',
      project: 'a.mgid.com',
    });
    const siblingScriptTag = document.getElementsByTagName('script')[0];
    const scriptTag = document.createElement('script');
    scriptTag.type = 'text/javascript';
    scriptTag.async = true;
    const dateTime = Date.now();
    scriptTag.src = `https://a.mgid.com/mgsensor.js?d=${dateTime}`;
    (siblingScriptTag.parentNode as Node).insertBefore(
      scriptTag,
      siblingScriptTag,
    );
  }
}
